<template>
	<div>
		<el-row>
			<el-col :span="24">
				<div class="bread">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
						<el-breadcrumb-item>匝道出入记录</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</el-col>
		</el-row>
		<el-row>
			<el-col :md="24">
				<el-button type="primary" icon="el-icon-paperclip" v-if="!($store.state.width>$store.state.minwidth)" style="float: right;" size="mini" @click="exportExcel()">导出</el-button>
				<el-date-picker class="find" style="margin-left: 0px;" v-model="quantum" type="daterange" v-if="$store.state.width>$store.state.minwidth" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
				<el-input v-model="find" class="find" placeholder="请输入内容" :size="$store.state.width<$store.state.minwidth?'mini':'medium'" style="top: -1px;">
					<el-button slot="append" icon="el-icon-search" @click="Find()">搜索</el-button>
				</el-input>
				<el-button type="primary" icon="el-icon-paperclip" v-if="$store.state.width>$store.state.minwidth" style="float: right;" @click="exportExcel()">导出</el-button>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<el-table id="table" :data="$store.state.production.turnover.list" size="mini" stripe border class="table">
					<el-table-column type="expand" width="20">
						<template slot-scope="props">
							<el-form label-position="left" class="slot_form">
								<el-row>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">名称</div>
										<div class="lable_value">{{ props.row.name }}</div>
									</el-col>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">匝道名称</div>
										<div class="lable_value">{{ props.row.rampInfo.name }}</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">物种名称</div>
										<div class="lable_value">{{ props.row.speciesInfo.alias }}</div>
									</el-col>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">rfid</div>
										<div class="lable_value">{{ props.row.speciesInfo.soleno }}</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">出入类型</div>
										<div class="lable_value">{{ props.row.typeName }}</div>
									</el-col>
									<el-col :md="12" class="slot_table">
										<div class="lable_name">出入时间</div>
										<div class="lable_value">{{ Totime(props.row.updatetime) }}</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="24" class="slot_table">
										<div class="lable_name">内容</div>
										<div class="lable_value">{{ props.row.content }}</div>
									</el-col>
								</el-row>
								<el-row>
									<el-col :md="24" class="slot_table">
										<div class="lable_name">描述</div>
										<div class="lable_value">{{ props.row.description }}</div>
									</el-col>
								</el-row>
							</el-form>
						</template>
					</el-table-column>
					<el-table-column type="index" width="40"></el-table-column>
					<el-table-column prop="rampInfo.name" label="匝道名称" width="160"></el-table-column>
					<el-table-column prop="rampno" label="匝道编号" width="120"></el-table-column>
					<el-table-column prop="speciesInfo.alias" label="物种名称" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column prop="speciesInfo.soleno" label="RFID编号" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
					<el-table-column prop="typeName" label="进出类型" width="80"></el-table-column>
					<el-table-column prop="updatetime" label="时间">
						<template slot-scope="scope">
							{{Totime(scope.row.updatetime)}}
						</template>
					</el-table-column>
					<el-table-column prop="description" label="描述" v-if="$store.state.width>$store.state.minwidth"></el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row class="pagin">
			<el-col :span="24">
				<div>
					<el-pagination background :small="$store.state.width<$store.state.minwidth" align="center" @size-change="changeSize" @current-change="nextpage" :current-page="$store.state.production.page" :page-sizes="[20, 50, 100, 200]" :page-size="$store.state.production.pagesize" :layout="$store.state.width>$store.state.minwidth?'total, sizes, prev, pager, next, jumper':'prev, pager, next'" :total="$store.state.production.turnover.page.total"></el-pagination>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import FileSaver from 'file-saver';
	import XLSX from 'xlsx';
	export default {
		data() {
			return {
				find: '',
				quantum: []
			}
		},
		watch: {
			$route: {
				handler: function(val, oldVal){
					
				}
			}
		},
		mounted: function () {
			this.$store.commit('pagesize',20);
			this.$store.commit('page',1);
			this.load();
		},
		methods: {
			load()
			{
				this.$store.commit('mainload',true);
				this.getturnover()
				.then(()=>{
					this.$store.commit('mainload',false);
				});
			},
			changeSize(val) {
				this.$store.commit('pagesize',val);
				this.$store.commit('page',1);
				this.load();
			},
			nextpage(val) {
				this.$store.commit('page',val);
				this.load();
			},
			Find()
			{
				let value={
					keyword: this.find
				};
				if(this.quantum!=null&&this.quantum.length==2)
				{
					value.startTime=this.quantum[0].getTime()/1000;
					value.endTime=this.quantum[1].getTime()/1000;
				}
				this.$store.commit('page',1);
				this.getturnover(value);
			},
			exportExcel() {
				/* npm install --save xlsx file-saver 需要获取依赖 */
				var wb = XLSX.utils.table_to_book(document.querySelector('.table'))
				/* get binary string as output */
				var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
				try {
					FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'sheetjs.xlsx')
				} catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
				this.$message({message: '导出成功！',type: 'success'});
				return wbout
			}
		}
	}
</script>

<style scoped>
	.bread{
		height: 14px;
		padding: 8px 0;
	}
	.output{
		text-align: right;
	}
	.table{
		margin-top: 10px;
		width: 100%;
	}
	.add{
		margin-top: 1px;
	}
	.find{
		width: 300px;
		margin-left: 15px;
	}
	.pagin{
		margin-top: 10px;
	}
	.fm-img{
		width: 100px;
		height: 100px;
		border: 1px solid #d9d9d9;
		border-radius: 6px;
	}
		.slot_table{
		border: 1px solid #EBEEF5;
		border-collapse: collapse ;
	}
	.slot_table>.el-form-item {
		margin-bottom: 0px;
		color: #1991FA;
	}
	.slot_form{
		width: 70%;
		margin: 0 auto;
	}
	.lable_name{
		vertical-align: middle;
		float: left;
		font-size: 14px;
		color: #606266;
		line-height: 40px;
		padding: 0 12px 0 0;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		width: 30%;
		padding-left: 0.75rem;
		/* border-right: 1px solid #EBEEF5; */
	}
	.lable_value{
		line-height: 40px;
		float: left;
		font-size: 14px;
		color: #1991FA;
		width: 70%;
		text-align: center;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.slot_form{
			width: 100%;
		}
		.find{
			width: 100% !important;
			margin-left: 0px;
			margin-top: 5px;
		}
	}
</style>

<style>
	.el-message-box {
		width: 350px !important;
	}
</style>